import React from 'react'
import { ReactComponent as SearchIcon } from '../../assets/icons/search.svg';
import { ReactComponent as CloseSearchIcon } from '../../assets/icons/searchClose.svg';

const Searchbox = ({ label, placeholder, value, onChange, handelClear, searchIconClass }) => {
    return (
        <div className='w-100 bg-transparent'>
            {label && <label htmlFor="">{label}</label>}
            <div className={`flex w-100 !text-black700 rounded-lg !h-9 !px-4 py-2 !border items-center ${value ? '!border-primary' : 'border-grayLight   focus:!border-primary w-100 '}`}>
                <div className=""><SearchIcon className={`${searchIconClass}`} /></div>
                <input
                    type="text"
                    className={` w-100  !ml-1 placeholder:!text-black700 focus:outline-0 `}
                    onChange={onChange}
                    value={value}
                    placeholder={placeholder}
                />
                {value && <button onClick={handelClear}><CloseSearchIcon /></button>}
            </div>
        </div>
    )
}

export default Searchbox
